import {Component, OnInit} from '@angular/core';
import { FormsUtils } from 'src/app/utils/FormUtils';

@Component({
    selector: 'app-sms',
    templateUrl: './sms.component.html',
    styleUrls: ['./sms.component.scss']
})
export class SmsComponent implements OnInit {

    idForm: string;

    constructor(private _formsUtils: FormsUtils) {
    }

    ngOnInit(): void {
        this.idForm = this._formsUtils.getFormIdByLang();
        this._formsUtils.buildSovosForm();
    }

}
